"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LastExerciseDateSchema = exports.OptionsGrantExerciseSchema = exports.OptionsGrantManageSchema = void 0;
const yup = __importStar(require("yup"));
const moment_1 = __importDefault(require("moment"));
const constants_1 = require("../constants");
const OptionGrant_1 = require("./OptionGrant");
const BEFORE_GRANT_DATE = "Date cannot be before grant date";
const optionNumber = (manageType) => yup
    .number()
    .typeError(constants_1.NUMBER_MUST_BE_POSITIVE)
    .integer(constants_1.NUMBER_MUST_BE_POSITIVE)
    .positive(constants_1.NUMBER_MUST_BE_POSITIVE)
    .test("optionNumber", "Number of options must not exceed the available amount", function test(numberOfOptions) {
    if (this.options.context) {
        const { optionsAvailable } = this.options.context;
        if (numberOfOptions > optionsAvailable) {
            return this.createError({
                message: `${optionsAvailable} options are available to ${manageType}`,
            });
        }
        return true;
    }
    return true;
});
const commonDateValidation = () => yup
    .string()
    .typeError(constants_1.DATE_VALID)
    .required(constants_1.DATE_REQUIRED)
    .test("date valid", constants_1.DATE_VALID, (date) => (0, moment_1.default)(date).isValid())
    .test("date not before grant date", constants_1.DATE_VALID, function test(dateValue) {
    if (this.options.context) {
        const { grantDate } = this.options.context;
        if ((0, moment_1.default)(dateValue).isBefore((0, moment_1.default)(grantDate))) {
            return this.createError({
                message: `Date cannot be before ${grantDate}`,
            });
        }
    }
    return true;
});
exports.OptionsGrantManageSchema = yup.object().shape({
    optionNumber: optionNumber("vest"),
    vestingDate: commonDateValidation().test("date not after last exercise date", constants_1.DATE_VALID, function test(date) {
        if (this.options.context) {
            const { lastExerciseDate } = this.options.context;
            if ((0, moment_1.default)(date).isAfter((0, moment_1.default)(lastExerciseDate))) {
                return this.createError({
                    message: `Date cannot be after ${lastExerciseDate}`,
                });
            }
        }
        return true;
    }),
});
exports.OptionsGrantExerciseSchema = yup.object().shape({
    optionNumber: optionNumber("exercise"),
    exerciseDate: commonDateValidation().test("date not in future", "Exercise date cannot be in the future", (exerciseDate) => (0, moment_1.default)(exerciseDate).isBefore((0, moment_1.default)())),
    authorisingOfficer: OptionGrant_1.AuthorisingOfficerSchema,
});
// This schema is reused on front and backend, and grantDate is needed to ensure lastExerciseDate is not set prior to it
exports.LastExerciseDateSchema = yup.object().shape({
    grantDate: yup.date().notRequired(),
    exercisePrice: yup
        .number()
        // error message for empty data string ("")
        .typeError("Please enter Exercise price")
        .required("Exercise price is required"),
    lastExerciseDate: yup
        .date()
        .label("Last exercise date")
        .typeError("Please enter Exercise expiry date")
        .required(constants_1.DATE_REQUIRED)
        // grantDate is used for the backend validation, and $grantDateFrontEnd is used for frontend
        .when(["grantDate", "$grantDateFrontEnd"], ([grantDate, grantDateFrontEnd], schema) => grantDate
        ? schema.test("Date-in-past", BEFORE_GRANT_DATE, (lastExerciseDate) => new Date(lastExerciseDate) >= new Date(new Date(grantDate).setHours(0, 0, 0, 0)))
        : schema.test("Date-in-past", BEFORE_GRANT_DATE, (lastExerciseDate) => new Date(lastExerciseDate) >= new Date(new Date(grantDateFrontEnd).setHours(0, 0, 0, 0)))),
});
//# sourceMappingURL=OptionsGrantManageSchema.js.map